import {HttpClient, HttpContext} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ProfilePhotoUploadResponse} from '@gatewee/types/profile-photo';
import {Observable, tap} from 'rxjs';
import {readProfileRaw} from './auth/auth-token.storage';
import {ProfileSyncService} from './profile-sync.service';
import {SKIP_SPINNER} from './tokens/spinner.token';

@Injectable({
  providedIn: 'root',
})
export class ProfilePhotoService {
  constructor(
    private readonly http: HttpClient,
    private readonly profileSync: ProfileSyncService,
  ) {}

  getCurrentPhotoUrl(): string {
    try {
      const profile = JSON.parse(readProfileRaw()) as {profilePhoto?: string};
      return profile.profilePhoto ?? '';
    } catch {
      return '';
    }
  }

  getCurrentUserName(): string {
    try {
      const profile = JSON.parse(readProfileRaw()) as {name?: string};
      return profile.name ?? '';
    } catch {
      return '';
    }
  }

  upload(file: File): Observable<ProfilePhotoUploadResponse> {
    const form = new FormData();
    form.append('file', file);

    return this.http
      .post<ProfilePhotoUploadResponse>('/auth/profile/photo', form, {
        context: new HttpContext().set(SKIP_SPINNER, true),
      })
      .pipe(
        tap(response => {
          if (response?.profilePhoto) {
            this.profileSync.applyProfilePhoto(response.profilePhoto);
          }
        }),
      );
  }
}
